export default "__VITE_ASSET__65afcf28__"